(async() => {
while(!window.hasOwnProperty("jQuery")||!jQuery.fn.validate||!jQuery.fn.mask) {
    await new Promise(resolve => setTimeout(resolve, 100));
}


'use strict';
var $ = jQuery;

var _calc = {

  init: function (){
    _calc.setWaterCalc();
    _calc.setVLCalc();
    _calc.setGCalc();
  },

  runWaterCalc: function(formEls){
    var $results = formEls.form.find('.results'),
    result = 0, Q = parseFloat(formEls.mfr.val()), p1 = parseFloat(formEls.ip.val()), p2 = parseFloat(formEls.op.val());
    result = Q / Math.sqrt(p1 - p2);
    $results.html('<div>Calculated Cv = ' + result.toFixed(2) + '</div>');
  },

  setWaterCalc: function(){
    var formEls = {
      form: $("#WaterCalc"),
      mfr : $('#WaterMfr'),
      ip  : $('#WaterIp'),
      op  : $('#WaterOp')
    };
    $.validator.addMethod("digitsonly", function(value, element) {
      return this.optional(element) || /^[0-9.]+$/i.test(value);
    }, "Digits only");
    $.validator.addMethod("greaterThan", function (value, element, param) {
      var $otherElement = $(param);
      return parseFloat(value, 10) > parseFloat($otherElement.val(), 10);
    }, 'Should be greater than Outlet pressure');
    formEls.mfr.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.ip.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.op.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.form.validate({
      rules: {
        "WaterMfr": {
          required: true,
          digitsonly: true
        },
        "WaterIp": {
          required: true,
          digitsonly: true,
          greaterThan: "#WaterOp"
        },
        "WaterOp": {
          required: true,
          digitsonly: true
        }
      },
      submitHandler: function(form) {
        _calc.runWaterCalc(formEls);
        return false;
      }
    });
  },
  runVLCalc: function(formEls){
    var $results = formEls.form.find('.results'),
    result = 0, Q = parseFloat(formEls.mfr.val()), p1 = parseFloat(formEls.ip.val()), p2 = parseFloat(formEls.op.val()), SG = parseFloat(formEls.gr.val()), u = parseFloat(formEls.vis.val()), exp = parseFloat(2/3);
    var tf = (Q/(1 * 1)) * Math.sqrt(SG/(p1 - p2));
    var lf = parseFloat(1/1.05) * Math.pow(((Q*u)/(52.3*(p1 - p2))),exp);
    var CvRatio = parseFloat(tf / lf);
    result = (CvRatio < 0.46) ? lf : tf;
    $results.html('<div>Calculated Cv = ' + result.toFixed(2) + '</div>');
  },
  setVLCalc: function(){
    var formEls = {
      form : $("#VLCalc"),
      mfr  : $('#VLMfr'),
      ip   : $('#VLIp'),
      op   : $('#VLOp'),
      gr   : $('#VLGr'),
      vis  : $('#VLVis')
    }
    $.validator.addMethod("digitsonly", function(value, element) {
      return this.optional(element) || /^[0-9.]+$/i.test(value);
    }, "Digits only");
    $.validator.addMethod("greaterThan", function (value, element, param) {
      var $otherElement = $(param);
      return parseFloat(value, 10) > parseFloat($otherElement.val(), 10);
    }, 'Should be greater than Outlet pressure');
    formEls.mfr.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.ip.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.op.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.gr.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.vis.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.form.validate({
      rules: {
        "VLMfr": {
          required: true,
          digitsonly: true
        },
        "VLIp": {
          required: true,
          digitsonly: true,
          greaterThan: "#VLOp"
        },
        "VLOp": {
          required: true,
          digitsonly: true
        },
        "VLGr": {
          required: true,
          digitsonly: true
        },
        "VLVis": {
          required: true,
          digitsonly: true
        }
      },
      submitHandler: function(form) {
        _calc.runVLCalc(formEls);
        return false;
      }
    });
  },
  runGCalc: function(formEls){
    var $results = formEls.form.find('.results'),
    result = 0, Q = parseFloat(formEls.mfr.val()), p1 = parseFloat(formEls.ip.val()), p2 = parseFloat(formEls.op.val()), SG = parseFloat(formEls.gr.val()), T = parseFloat(formEls.temp.val());
    result = parseFloat(Q/(16.05 * Math.sqrt((Math.pow(p1,2) - Math.pow(p2,2))/(SG * (T+460)))));
    $results.html('<div>Calculated Cv = ' + result.toFixed(2) + '</div>');
  },
  setGCalc: function() {
    var formEls = {
      form: $("#GCalc"),
      mfr : $('#GMfr'),
      ip  : $('#GIp'),
      op  : $('#GOp'),
      gr  : $('#GGr'),
      temp: $('#GTemp')
    };
    $.validator.addMethod("digitsonly", function(value, element) {
      return this.optional(element) || /^[0-9.]+$/i.test(value);
    }, "Digits only");
    $.validator.addMethod("greaterThan", function (value, element, param) {
      var $otherElement = $(param);
      return parseFloat(value, 10) > parseFloat($otherElement.val(), 10);
    }, 'Should be greater than Outlet pressure');
    formEls.mfr.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.ip.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.op.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.gr.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.temp.mask('ZZZZZZZZZZZZ',{translation:  {'Z': {pattern: /[0-9.]/, optional: true}}});
    formEls.form.validate({
      rules: {
        "GMfr": {
          required: true,
          digitsonly: true
        },
        "GIp": {
          required: true,
          digitsonly: true,
          greaterThan: "#GOp"
        },
        "GOp": {
          required: true,
          digitsonly: true
        },
        "GGr": {
          required: true,
          digitsonly: true
        },
        "GTemp": {
          required: true,
          digitsonly: true
        }
      },
      submitHandler: function(form) {
        _calc.runGCalc(formEls);
        return false;
      }
    });
  }
};

$(document).ready(_calc.init);

})();